import React from "react";
import RenderRoutes from "./components/RenderRoutes";
import "./styles/Main.scss";

import PoolsContextProvider from "./context/poolsContext";
import ConfiguredWagmiProvider from "./context/ConfiguredWagmiProvider";
import { client } from "./prismic";
import ErrorBoundary from "./components/ErrorBoundary";
import { PrismicProvider } from "@prismicio/react";

const Main = () => {
  return (
    <ConfiguredWagmiProvider>
      <PrismicProvider client={client}>
        <ErrorBoundary>
          <PoolsContextProvider>
            <RenderRoutes />
          </PoolsContextProvider>
        </ErrorBoundary>
      </PrismicProvider>
    </ConfiguredWagmiProvider>
  );
};

export default Main;
